import pigletAccountingPackageApi from "@/api/piglet/pigletAccountingPackage";
import pigStyAccountingPackageApi from '@/api/pigSty/accountingPackageApi';
import dateFormatter from "@/components/formatter/dateFormatter";

export default {
  namespaced: true,
  states: {},
  mutations: {},
  actions: {
    async create({dispatch}, form) {
      try {
        const response = await pigStyAccountingPackageApi.create(form);

        return Promise.resolve(response.data);
        /*window.open("/api-article/api/accounting-package/v1/download?mode=All&token=" + response.data.token);

        await dispatch('reporting/printReport', {
          reportId: response.data.fibuReportName,
          merge: null,
          data: response.data.fibuReportModel
        }, {root: true});
        await dispatch('reporting/printReport', {
          reportId: response.data.elbaReportName,
          merge: null,
          data: response.data.elbaReportModel
        }, {root: true});
        await dispatch('reporting/saveForPreview', {
          id: response.data.fibuReportName,
          silent: true,
          items: response.data.fibuReportModel
        }, {root: true});
        return Promise.resolve();
      } catch (error) {
        dispatch("NOTIFY_ERROR", error, {root: true});
        return await Promise.reject(error);*/
      } catch (error) {
        dispatch("NOTIFY_ERROR", error, {root: true});
        return await Promise.reject(error);
      }
    },
    async download({dispatch}, {id, mode}) {
      try {
        const response = await pigStyAccountingPackageApi.requestDownload(id);
        window.open(`/api-article/v1/accounting-package/download?mode=${mode}&token=${response.data.token}`);
        return Promise.resolve();
      } catch (error) {
        dispatch("NOTIFY_ERROR", error, {root: true});
        return await Promise.reject(error);
      }
    },
    async createCredits({dispatch}, form) {
      try {
        await pigletAccountingPackageApi.createCredits(form);
        return Promise.resolve();
      } catch (error) {
        dispatch("NOTIFY_ERROR", error, {root: true});
        return await Promise.reject(error);
      }
    },
    async fetchTodo({dispatch}, {context}) {
      try {
        //TODO switch api dependent on the context
        let todo = {};
        switch(context) {
          default:
            todo = await pigletAccountingPackageApi.fetchTodo(context);
            break;
          case "PigSty":
            todo = await pigStyAccountingPackageApi.fetchTodo();
            break;
        }
        const todoFormatted = {
          creditDates: todo.data.creditDates.map(item => {
            return {text: dateFormatter(item), value: item}
          }),
          invoiceDates: todo.data.invoiceDates.map(item => {
            return {text: dateFormatter(item), value: item}
          }),
        }
        return Promise.resolve(todoFormatted);
      } catch (error) {
        dispatch("NOTIFY_ERROR", error, {root: true});
        return await Promise.reject(error);
      }
    }
  }
}
